import { useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import {
  Action,
  BatasBatasTanah,
  ButtonGroup,
  Deskripsi,
  InputField,
  SelectionField,
} from "./Inputs";
import Loading from "./Loading";
import { IconButton } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";

export default function FormEdit({ data }) {
  const types = ["tanah", "ruko", "rumah", "kantor"];
  const sertif = ["shm", "shgb", "shsrs", "hgu", "ajb", "girik", "shp"];

  const [tipe, setTipe] = useState(data.tipe);
  const [harga, setHarga] = useState(data.harga);
  const [sertifikasi, setSertifikasi] = useState(data.sertifikasi);
  const [luasTanah, setLuasTanah] = useState(data.luasTanah);
  const [luasBangun, setLuasBangun] = useState(data.luasBangun);
  const [bahan, setBahan] = useState(data.bahan);
  const [lantai, setLantai] = useState(data.jumlahLantai);
  const [dibangun, setDibangun] = useState(data.dibangun);
  const [direnov, setDirenov] = useState(data.direnov);
  const [posisiBangunan, setPosisiBangunan] = useState(data.posisiBangunan);
  const [orientasi, setOrientasi] = useState(data.orientasi);
  const [bentuk, setBentuk] = useState(data.bentukTanah);
  const [elevasi, setElevasi] = useState(data.elevasi);
  const [sumber, setSumber] = useState(data.sumber);
  const [noHPAdmin, setNoHPAdmin] = useState(data.noHPAdmin);
  const [noHPPemilik, setNoHPPemilik] = useState(data.noHPPemilik);
  const [wilayah, setWilayah] = useState(data.wilayah);
  const [alamat, setAlamat] = useState(data.alamat);
  const [koordinat, setKoordinat] = useState(data.koordinat);
  const [deskripsi, setDeskripsi] = useState(data.deskripsi);

  const [depan, setDepan] = useState(data.batasTanah[0]);
  const [kiri, setKiri] = useState(data.batasTanah[1]);
  const [kanan, setKanan] = useState(data.batasTanah[2]);
  const [belakang, setBelakang] = useState(data.batasTanah[3]);
  const [tanggalPenawaran, setTanggalPenawaran] = useState(
    new Date(data.tanggalPenawaran).toISOString().slice(0, 10)
  );

  const [imageSelect, setImageSelect] = useState("prev");
  const [prevFoto, setPrevFoto] = useState(data.foto);
  const [foto, setFoto] = useState([]);
  const [countPhoto, setCountPhoto] = useState(1);

  const [loading, setLoading] = useState(false);

  const fields = [
    {
      label: "Harga (harga tertinggi)",
      type: "text",
      state: [harga, setHarga],
      required: true,
    },
    {
      label: "Luas Tanah (meter persegi)",
      type: "text",
      state: [luasTanah, setLuasTanah],
      required: true,
    },
    {
      label: "Bentuk Tanah",
      type: "text",
      state: [bentuk, setBentuk],
      required: true,
    },
    {
      label: "Elevasi",
      type: "text",
      state: [elevasi, setElevasi],
      required: true,
    },
    { label: "Sumber Informasi", type: "text", state: [sumber, setSumber] },
    {
      label: "No. Telp Admin (* 895-4398-dst)",
      type: "text",
      state: [noHPAdmin, setNoHPAdmin],
      required: true,
    },
    {
      label: "No. Telp Pemilik  (* 895-4398-dst)",
      type: "text",
      state: [noHPPemilik, setNoHPPemilik],
      required: true,
    },
    {
      label: "Wilayah",
      type: "text",
      state: [wilayah, setWilayah],
      required: true,
    },
    {
      label: "Alamat",
      type: "text",
      state: [alamat, setAlamat],
      required: true,
    },
    {
      label: "Koordinat",
      type: "text",
      state: [koordinat, setKoordinat],
      required: true,
    },
    {
      label: "Tanggal Penawaran",
      type: "date",
      state: [tanggalPenawaran, setTanggalPenawaran],
      required: true,
    },
  ];

  const disabled = [
    {
      label: "Luas Bangunan (meter persegi)",
      type: "text",
      state: [luasBangun, setLuasBangun],
      disabled: tipe === "tanah",
    },
    {
      label: "Bahan Bangunan",
      type: "text",
      state: [bahan, setBahan],
      disabled: tipe === "tanah",
    },
    {
      label: "Jumlah Lantai",
      type: "text",
      state: [lantai, setLantai],
      disabled: tipe === "tanah",
    },
    {
      label: "Tahun Dibangun",
      type: "text",
      state: [dibangun, setDibangun],
      disabled: tipe === "tanah",
    },
    {
      label: "Tahun Direnovasi",
      type: "text",
      state: [direnov, setDirenov],
      disabled: tipe === "tanah",
    },
  ];

  const navigate = useNavigate();

  const handleTipe = (value) => {
    setTipe(value);
  };

  const handleSertifikasi = (value) => {
    setSertifikasi(value);
  };

  const validate = () => {
    if (
      !tipe ||
      !sertifikasi ||
      !luasTanah ||
      !harga ||
      !koordinat ||
      !alamat ||
      !bentuk ||
      !elevasi
    ) {
      return false;
    }
    return true;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validate()) {
      swal
        .fire({
          title: "Edit Data Gagal!",
          icon: "error",
          text: "Data yang diisi tidak lengkap!",
          confirmButtonText: "Close",
          timer: 1000,
        })
        .then(() => {
          setLoading(false);
        });
      return false;
    }

    const formData = new FormData();

    formData.append("tipe", tipe);
    formData.append("sertifikasi", sertifikasi);
    formData.append("harga", harga);
    formData.append("luasTanah", luasTanah);
    formData.append("luasBangun", luasBangun);
    formData.append("bahan", bahan);
    formData.append("alamat", alamat);
    formData.append("jumlahLantai", lantai);
    formData.append("direnov", direnov);
    formData.append("dibangun", dibangun);
    formData.append("posisiBangunan", posisiBangunan);
    formData.append("orientasi", orientasi);
    formData.append("batasTanah[]", depan);
    formData.append("batasTanah[]", kiri);
    formData.append("batasTanah[]", kanan);
    formData.append("batasTanah[]", belakang);
    formData.append("bentukTanah", bentuk);
    formData.append("elevasi", elevasi);
    formData.append("sumber", sumber);
    formData.append(
      "wilayah",
      wilayah.charAt(0).toUpperCase() + wilayah.slice(1)
    );
    formData.append("noHPAdmin", noHPAdmin);
    formData.append("noHPPemilik", noHPPemilik);
    formData.append("koordinat", koordinat);
    formData.append("deskripsi", deskripsi);
    formData.append("tanggalPenawaran", tanggalPenawaran);

    if (imageSelect === "prev") {
      prevFoto.forEach((file) => {
        formData.append("prevFoto[]", JSON.stringify(file));
      });
    } else if (imageSelect === "add") {
      prevFoto.forEach((file) => {
        formData.append("prevFoto[]", JSON.stringify(file));
      });
      foto.forEach((file) => {
        formData.append("foto[]", file);
      });
    } else {
      foto.forEach((file) => {
        formData.append("foto[]", file);
      });
    }

    try {
      const response = await fetch(
        `https://kjpp-server.vercel.app/api/properties/update/${data._id}`,
        {
          method: "PATCH",
          body: formData,
        }
      );

      if (response.ok) {
        swal
          .fire({
            title: "Edit Data Success!",
            icon: "success",
            confirmButtonText: "Close",
            timer: 1000,
          })
          .then(() => {
            navigate("/");
          });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const convertBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleUpload = async (e, i) => {
    const photos = [...foto];
    const base64 = await convertBase64(e.target.files[0]);
    photos[i] = base64;

    setFoto(photos);
  };

  return (
    <form>
      {loading && (
        <div className="h-screen w-full flex justify-center items-center">
          <Loading />
        </div>
      )}

      {!loading && (
        <div className="flex flex-wrap justify-between gap-5">
          <div className="w-full mb-5 md:w-[48%]">
            <label
              htmlFor=""
              className="block mb-2 after:content-['*'] after:text-pink-500 after:ml-0.5"
            >
              Tipe
            </label>
            <ButtonGroup
              options={types}
              selectedOption={tipe}
              onChange={handleTipe}
            />
          </div>
          <div className="w-full mb-5 md:w-[48%]">
            <label
              htmlFor=""
              className="block mb-2 after:content-['*'] after:text-pink-500 after:ml-0.5"
            >
              Sertifikasi
            </label>
            <ButtonGroup
              options={sertif}
              selectedOption={sertifikasi}
              onChange={handleSertifikasi}
            />
          </div>
          {fields.map((field) => (
            <InputField
              label={field.label}
              type={field.type}
              key={field.label}
              required={field.required}
              value={field.state[0]}
              onChange={(e) => {
                field.state[1](e.target.value);
              }}
            />
          ))}
          {disabled.map((field) => (
            <InputField
              label={field.label}
              key={field.label}
              type={field.type}
              value={field.state[0]}
              onChange={(e) => {
                field.state[1](e.target.value);
              }}
              disabled={field.disabled}
            />
          ))}
          <BatasBatasTanah
            label={"Batas-batas Tanah"}
            depan={depan}
            kiri={kiri}
            kanan={kanan}
            belakang={belakang}
            setDepan={setDepan}
            setBelakang={setBelakang}
            setKanan={setKanan}
            setKiri={setKiri}
          />

          <div className="w-full mb-5 md:w-[48%]">
            <label htmlFor="" className="block mb-2">
              Foto
            </label>
            <div className="flex gap-5 mb-5">
              <button
                className={`border py-2 px-4 rounded-sm ${
                  imageSelect === "prev" ? "bg-primary text-white" : ""
                }`}
                onClick={() => setImageSelect("prev")}
                type="button"
              >
                Prev
              </button>
              <button
                className={`border py-2 px-4 rounded-sm ${
                  imageSelect === "new" ? "bg-primary text-white" : ""
                }`}
                onClick={() => setImageSelect("new")}
                type="button"
              >
                New
              </button>
              <button
                className={`border py-2 px-4 rounded-sm ${
                  imageSelect === "add" ? "bg-primary text-white" : ""
                }`}
                onClick={() => setImageSelect("add")}
                type="button"
              >
                Add
              </button>
            </div>
            {imageSelect !== "prev" && (
              <div>
                {Array.from({ length: countPhoto }).map((_, i) => (
                  <input
                    key={i}
                    type="file"
                    accept=".jpg, .png, .jpeg"
                    className="border border-slate-400 rounded-md mb-2 px-4 py-[9px] w-full"
                    onChange={(e) => {
                      handleUpload(e, i);
                    }}
                  />
                ))}

                <div className="flex">
                  <IconButton
                    onClick={() => {
                      setCountPhoto(countPhoto + 1);
                    }}
                  >
                    <Add />
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      setFoto(foto.slice(0, countPhoto - 1));
                      setCountPhoto(countPhoto - 1);
                    }}
                    disabled={countPhoto < 2}
                  >
                    <Remove />
                  </IconButton>
                </div>
              </div>
            )}
          </div>

          <SelectionField
            label={"Posisi Bangunan / Tanah"}
            value={posisiBangunan}
            onChange={setPosisiBangunan}
            menus={["depan", "kanan", "tengah", "kiri", "belakang", "-"]}
          />
          <SelectionField
            label={"Orientasi Bangunan"}
            value={orientasi}
            onChange={setOrientasi}
            menus={[
              "utara",
              "barat",
              "timur",
              "selatan",
              "barat daya",
              "tenggara",
              "timur laut",
              "barat laut",
              "-",
            ]}
          />

          <Deskripsi
            label={"Deskripsi"}
            value={deskripsi}
            onChange={setDeskripsi}
          />

          <div className="w-full">
            <Action label={"Update data"} handleClick={handleUpdate} />
          </div>
        </div>
      )}
    </form>
  );
}
